import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { PaginatedDockReservedInterval } from 'contracts/DockReservedIntervals';
import type { Pagination } from 'contracts/Pagination';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data', 'pagination'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'PAGINATE_DOCK_RESERVED_INTERVALS_',
  }
);

export interface PaginateDockReservedIntervalsState {
  data: PaginatedDockReservedInterval[];
  pagination?: Pagination;
  loading: boolean;
  errorMessage: string | null;
}

export interface PaginateDockReservedIntervalsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: PaginatedDockReservedInterval[];
  pagination: Pagination;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: PaginateDockReservedIntervalsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: PaginateDockReservedIntervalsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: PaginateDockReservedIntervalsState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
    pagination: { $set: action.pagination },
  });

const failure = (
  state: PaginateDockReservedIntervalsState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: PaginateDockReservedIntervalsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const paginateDockReservedIntervals = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const PaginateDockReservedIntervalsTypes = Types;
export const PaginateDockReservedIntervalsActions = Creators;
